// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__wQbaO","divider":"Counter_divider__DFKH6","invalid":"Counter_invalid__v5Ysa","disabled":"Counter_disabled__MBq7C","error":"Counter_error__qGAQy"};